import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Track if we're already redirecting to avoid loops
let redirecting = false;

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !redirecting) {
      redirecting = true;
      localStorage.removeItem('token');
      // Use replace so back button works
      window.location.replace('/login');
      return new Promise(() => {}); // never resolve — page is changing
    }
    // Only show error toast for non-login routes and non-404s from api
    const msg = err.response?.data?.message;
    if (msg && err.response?.status !== 401) toast.error(msg);
    return Promise.reject(err);
  }
);

export default api;

export const formatCurrency = (amount, symbol = '₹') =>
  `${symbol}${parseFloat(amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatDate = (date) => {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const getApiBase = () => process.env.REACT_APP_API_URL || '/api';
